import { render, staticRenderFns } from "./CodeHighlight.vue?vue&type=template&id=18ebe8d4&"
import script from "./CodeHighlight.vue?vue&type=script&lang=js&"
export * from "./CodeHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports